import React from "react";
import { COffcanvas, COffcanvasBody } from "@coreui/react";
import "./OffCanvasStyles.css";

const OffCanvasComponent = (props) => {
  const customStyles = {
    "--bs-offcanvas-width": props.width || "40%",
  };

  return (
    <>
      <COffcanvas
        style={customStyles}
        placement="end"
        visible={props.modalIsOpen}
        onHide={() => props.setIsOpen(false)}
      >
        <COffcanvasBody>{props.children}</COffcanvasBody>
      </COffcanvas>
    </>
  );
};

export default OffCanvasComponent;
